import React from 'react';
import TextInput from '../../../Shared/TextInput/TextInput';
import TextArea from '../../../Shared/TextArea/TextArea';

const PickupDeliveryContactPerson = (props) => {
  return (
    <div className='container pickup-delivery-bottom-wrapper'>
      <div className={'title-area'}>
        <span className={'setup-address-title'}>מי פוגש את השליח?</span>
        <span className={'setup-address-subTitle'}>*ישנה נוכחות חובה של אדם מעל גיל 18
בעת ביקור שליח</span>
      </div>
      <div className={'form'}>
        <div>
          <TextInput
            error={props.form.errors[props.contactNameForm]}
            placeholder="שם פרטי "
            onChange={(e) => props.changeHandler(e)}
            value={props.form[props.contactNameForm]}
            name={props.contactNameForm}
            type="text"
            required="required"
          />
        </div>
        <div>
          <TextInput
            error={props.form.errors[props.contactLastNameForm]}
            placeholder="שם משפחה"
            onChange={(e) => props.changeHandler(e)}
            value={props.form[props.contactLastNameForm]}
            name={props.contactLastNameForm}
            type="text"
            required="required"
          />
        </div>
        <div>
          <TextInput
            name={props.contactPhoneForm}
            type="tel"
            pattern="[0-9]*"
            id={props.contactPhoneForm}
            maxLength="10"
            autoComplete="off"
            placeholder={props.placeholder ?? 'מספר טלפון לבירורים'}
            required="required"
            value={props.form[props.contactPhoneForm]}
            error={props.form.errors[props.contactPhoneForm]}
            onChange={(e) => props.changeHandler(e)}
          />
        </div>
        <div>
          <TextInput
            name={props.contactNotesForm}
            id={props.contactPhoneForm}
            maxLength="250"
            autoComplete="off"
            placeholder={'כתבו כאן הערה או בקשה לשליח'}
            value={props.form[props.contactNotesForm]}
            error={props.form.errors[props.contactNotesForm]}
            onChange={(e) => props.changeHandler(e)}
          />
        </div>
      </div>
    </div>
  );
};

export default PickupDeliveryContactPerson;
